<!-- <div class="container-fluid"> -->

<offer-onb-field-details [disabled_fields]="lockOfferDetailsFlag" [form_details]="form_details" [type]="3"
  [verificationObj]="verificationObj" [disable_button]="lockOfferDetailsFlag">
</offer-onb-field-details>
<!-- </div> -->



<!-- <ng-template #error_message let-form_control="form_control" let-field_config_access="field_config_access">

  <ng-container *ngIf="form_control.hasError('required'); else min">
    <mat-error class="cust-error-msg">
      <span
        *ngIf="field_config_access['validators'] && field_config_access['validators']['mandatoryErrorMessage'];else mandatory_static_msg">
        {{field_config_access['validators']['mandatoryErrorMessage'] | translate}}
      </span>
      <ng-template #mandatory_static_msg>
        <span>
          {{'ERROR.field_is_mandatory' | translate}}
        </span>
      </ng-template>
    </mat-error>
  </ng-container>
  <ng-template #min>
    <ng-container *ngIf="form_control.hasError('min'); else max">
      <mat-error class="cust-error-msg">
        <span
          *ngIf="field_config_access['validators'] && field_config_access['validators']['minValueErrorMessage'];else min_static_msg">
          {{field_config_access['validators']['minValueErrorMessage'] | translate}}
        </span>
        <ng-template #min_static_msg>
          <span>
            {{'ERROR.min_value' +field_config_access['validators']['minValue'] | translate}}
          </span>
        </ng-template>
      </mat-error>
    </ng-container>
    <ng-template #max>
      <ng-container *ngIf="form_control.hasError('max'); else minlength">
        <mat-error class="cust-error-msg">
          <span
            *ngIf="field_config_access['validators'] && field_config_access['validators']['maxValueErrorMessage'];else max_static_msg">
            {{field_config_access['validators']['maxValueErrorMessage'] | translate}}
          </span>
          <ng-template #max_static_msg>
            <span>
              {{'ERROR.max_value' +field_config_access['validators']['maxValue'] | translate}}
            </span>
          </ng-template>
        </mat-error>
      </ng-container>
      <ng-template #minlength>
        <ng-container *ngIf="form_control.hasError('minlength'); else maxlength">
          <mat-error class="cust-error-msg">
            <span
              *ngIf="field_config_access['validators'] && field_config_access['validators']['minLengthErrorMessage'];else minLength_static_msg">
              {{field_config_access['validators']['minLengthErrorMessage'] | translate}}
            </span>
            <ng-template #minLength_static_msg>
              <span>
                {{'ERROR.min_length' +field_config_access['validators']['minLength'] | translate}}
              </span>
            </ng-template>
          </mat-error>
        </ng-container>
        <ng-template #maxlength>
          <ng-container *ngIf="form_control.hasError('maxlength'); else pattern">
            <mat-error class="cust-error-msg">
              <span
                *ngIf="field_config_access['validators'] && field_config_access['validators']['maxLengthErrorMessage'];else maxLength_static_msg">
                {{field_config_access['validators']['maxLengthErrorMessage'] | translate}}
              </span>
              <ng-template #maxLength_static_msg>
                <span>
                  {{'ERROR.max_length' +field_config_access['validators']['maxLength'] | translate}}
                </span>
              </ng-template>
            </mat-error>
          </ng-container>
          <ng-template #pattern>
            <ng-container *ngIf="form_control.hasError('pattern'); else common">
              <mat-error class="cust-error-msg">
                <span
                  *ngIf="field_config_access['validators'] && field_config_access['validators']['finalPatternErrorMessage'];else pattern_static_msg">
                  {{field_config_access['validators']['finalPatternErrorMessage'] | translate}}
                </span>
                <ng-template #pattern_static_msg>
                  <span>
                    {{'ERROR.invalid_input' | translate}}
                  </span>
                </ng-template>
              </mat-error>
            </ng-container>
            <ng-template #common>
              <mat-error class="cust-error-msg">
                <span
                  *ngIf="field_config_access['validators'] && field_config_access['validators']['generalErrorMessage'];else common_static_msg">
                  {{field_config_access['validators']['generalErrorMessage'] | translate}}
                </span>
                <ng-template #common_static_msg>
                  <span>
                    {{'ERROR.invalid_input' | translate}}
                  </span>
                </ng-template>
              </mat-error>
            </ng-template>

          </ng-template>

        </ng-template>

      </ng-template>

    </ng-template>

  </ng-template>

</ng-template> -->
